import {
   VisitMedicalInformationCreateCommand,
   VisitMedicalInformationQuery,
} from '@dreryk/egabinet-visit-frontend-api';

import { refetchCqrsQuery, useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';

import { VisitMedicalInformationCreateParameters } from './AddMedicalInformationLink.types';

type VisitInformationCreateActionOptions = {
   visitId: number;
};

export const useVisitMedicalInformationCreateCommand = (
   options: VisitInformationCreateActionOptions
): UseCqrsCommandResult<void, VisitMedicalInformationCreateParameters> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new VisitMedicalInformationCreateCommand();
         command.visitId = options.visitId;
         command.medicalInformationId = parameters.medicalInformationId;
         command.type = parameters.type;
         command.description = parameters.description;
         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(VisitMedicalInformationQuery);
         },
      }
   );
};
